import { ChipPropsColorOverrides } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

export const STATUS_COLORS: Record<
  string,
  OverridableStringUnion<'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning', ChipPropsColorOverrides>
> = {
  Active: 'success',
  Availble: 'info',
  Closing: 'warning',
  Closed: 'error',
};